import { isString } from 'lodash';

export function getOnlyNumber(str: string): string {
  if (!(isString(str))) {
    return str;
  }
  return str.replace(/[^\d\.]+/gi, '');
}
